const CONTENT_TYPE = 'application/json';

export class BadRequestError extends Error {
  public errors: any;

  constructor(errors: any) {
    super('Bad Request');
    this.name = 'BadRequestError';
    this.errors = errors;
  }
}

async function platformFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const opts = {
    credentials: 'include' as const,
    ...options,
  };
  opts.headers = {
    Accept: CONTENT_TYPE,
    ...(options.headers || {}),
  };
  if (opts.body) {
    if (typeof opts.body !== 'string') {
      opts.body = JSON.stringify(opts.body);
    }
    (opts.headers as Record<string, string>)['Content-Type'] = CONTENT_TYPE;
  }

  try {
    return await fetch(url, opts);
  } catch (err) {
    return err as Response;
  }
}

const http = {
  get: (url: string, options: RequestInit = {}): Promise<Response> => platformFetch(url, options),
  post: (url: string, body: BodyInit, options: RequestInit = {}): Promise<Response> =>
    platformFetch(url, {
      method: 'POST',
      body,
      ...options,
    }),
  put: (url: string, body: BodyInit, options: RequestInit = {}): Promise<Response> =>
    platformFetch(url, {
      method: 'PUT',
      body,
      ...options,
    }),
  patch: (url: string, body: BodyInit, options: RequestInit = {}): Promise<Response> =>
    platformFetch(url, {
      method: 'PATCH',
      body,
      ...options,
    }),
  delete: (url: string, options: RequestInit = {}): Promise<Response> =>
    platformFetch(url, {
      method: 'DELETE',
      ...options,
    }),
};

export default http;
